import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgWhatsAppAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.1518 23.0607C17.2557 26.7651 24.5647 22.6101 25.1847 16.5576C25.7459 11.0785 21.371 6.20338 15.4871 6.63195C8.76991 7.1211 4.73501 15.1393 8.86998 21.0071C8.50394 22.0101 8.1614 23.0367 7.84317 24.0875C8.31195 23.9518 8.7654 23.8007 9.21885 23.6497C9.84944 23.4396 10.48 23.2295 11.1518 23.0607ZM13.5479 10.3967L13.587 10.4783C14.2288 11.819 15.1503 13.744 13.5479 14.6181C14.3784 16.3737 15.7514 17.5867 17.541 18.383C17.9322 18.1242 18.2351 17.7771 18.538 17.4301C18.6959 17.2492 18.8538 17.0683 19.0242 16.8999C20.063 17.3062 21.034 17.7802 21.8763 18.383C21.9629 20.3457 20.309 21.0715 18.9101 21.007C15.9588 20.8712 11.9026 17.1427 10.9239 14.3899C10.3431 12.7565 11.0111 9.63235 13.5479 10.3967ZM2.25 2.24961C0 4.49883 0 8.11914 0 15.3602V16.6398C0 23.8809 0 27.5012 2.25 29.7504C4.49844 32 8.11875 32 15.3594 32H16.6406C23.8813 32 27.5016 32 29.75 29.7504C32 27.5012 32 23.8809 32 16.6398V15.3602C32 8.11914 32 4.49883 29.75 2.24961C27.5016 0 23.8813 0 16.6406 0H15.3594C8.11875 0 4.49844 0 2.25 2.24961ZM4.87695 26.9397C5.24784 25.7423 5.65504 24.5812 6.06223 23.4201C6.31658 22.6948 6.57098 21.9694 6.81647 21.2353C2.58383 13.8325 7.82194 5.49879 14.9167 4.80653C21.6154 4.15284 27.1076 8.96432 27.1242 15.5308C27.1417 22.4595 20.4218 28.2776 12.8631 25.9128C12.6417 25.8435 12.3998 25.7135 12.1479 25.578C11.7512 25.3647 11.3296 25.1381 10.9236 25.1142C10.2693 25.0756 9.47169 25.3956 8.72974 25.6932C8.41968 25.8176 8.11927 25.9381 7.84317 26.0269C7.57906 26.1119 7.32382 26.1969 7.07255 26.2806C6.34705 26.5222 5.65417 26.753 4.87695 26.9397Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgWhatsAppAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
